import { IconProps } from "../../utils/global-types/global-types";

type CloseIconProps = IconProps & {
  strokeWidth?: number;
};

const CloseIcon = ({
  className,
  strokeWidth = 1.5,
  ...rest
}: CloseIconProps) => {
  return (
    <svg
      viewBox="0 0 7 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-6 h-6"}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      <path d="M1 1L6 6" stroke="currentColor" strokeWidth={strokeWidth} />
      <path d="M6 1L1 6" stroke="currentColor" strokeWidth={strokeWidth} />
    </svg>
  );
};

export default CloseIcon;
